module.exports = __webpack_public_path__ + "img/cannon20ex_icon.ae32bf14.png";